import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// third-party
import { IntlProvider } from 'react-intl';

import { SUPPORTED_LANGUAGES } from 'constants/customizationConstants';
import * as actionTypes from 'store/actions';

// load locales files
const loadLocaleData = (locale) => {
    switch (locale) {
        case 'es':
            return import('utils/locales/es.json');
        case 'pt':
            return import('utils/locales/pt.json');
        default:
            return import('utils/locales/en.json');
    }
};

// ===========================|| LOCALIZATION ||=========================== //

const Locales = ({ children }) => {
    const customization = useSelector((state) => state.customization);
    const [messages, setMessages] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        loadLocaleData(customization.locale).then((d) => {
            setMessages(d.default);
        });
    }, [customization.locale]);

    useEffect(() => {
        const browserLanguage = navigator.language?.split('0')[0];

        if (!customization.locale && SUPPORTED_LANGUAGES.includes(browserLanguage)) {
            dispatch({ type: actionTypes.THEME_LOCALE, locale: browserLanguage });
        }
    }, [dispatch, customization.locale]);

    return (
        <>
            {messages && (
                <IntlProvider locale={customization.locale || 'en'} defaultLocale="en" messages={messages}>
                    {children}
                </IntlProvider>
            )}
        </>
    );
};

Locales.propTypes = {
    children: PropTypes.node
};

export default Locales;
